
import ReviewResourceView from '@/mixins/ReviewResourceView';
import { mapState, mapGetters, mapActions } from 'vuex';
import ThumbnailShape from '@/enums/ThumbnailShape';

export default {
  i18nComponentKey: 'WidgetCategoryReviewsBestGallery.components.BestGallery',
  name: 'BestGallery',
  mixins: [ReviewResourceView],
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    ...mapState('widget', ['isMobile']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection',
      'thumbnailShape'
    ]),
    displayOptions() {
      if (this.isMobile) {
        switch (this.widget.posts_per_line) {
          case 2:
            return { cols: 2, gutter: 16, productImageSize: 32 };
          case 3:
            return { cols: 3, gutter: 14, productImageSize: 32 };
          default:
            return { cols: 1, gutter: 0, productImageSize: 40 };
        }
      } else {
        return {
          cols: this.widget.layout_column,
          gutter: this.widget.column_gap,
          rowGap: this.widget.row_gap,
          minCardWidth: 100
        };
      }
    },
    productThumbnailType() {
      return this.widget.product_thumbnail_shape === ThumbnailShape.SQUARE
        ? 'rounded'
        : 'circle';
    },
    styleProps() {
      const { background_color, layout_column, column_gap } = this.widget;
      return {
        backgroundColor: background_color,
        '--layout-column': layout_column,
        '--column-gap': column_gap ? `${column_gap}px` : ''
      };
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
